<kendo-appbar position="top">

    <kendo-appbar-section>
        <img alt="Logo" class="logo" src="./assets/img/brand/{{brand}}/logo_partner.png">
        <span *ngIf="isTrainingEnv" class="env-display-name">{{'global.testEnvInfoName' | translate}}</span>
    </kendo-appbar-section>

    <kendo-appbar-spacer></kendo-appbar-spacer>

    <!-- <kendo-appbar-section>
    <a class="navigation-tabs__link" routerLink="/dealerCenter">{{'layout.topToolbarClaimsPanel' | translate}}</a>
  </kendo-appbar-section>

  <span class="k-appbar-separator navigation-tabs__separator"></span> -->

    <kendo-appbar-section>
        <div fxLayout="row">

            <button #anchor class="k-button k-button-clear profile-item" (click)="showUserProfile()">
                <kendo-icon name="user"></kendo-icon>
                <div fxLayout="column">

                    <span class="user-name">{{user.userData.userName}}</span>
                    <strong *ngIf="!!userCalculationProfile" class="user-profile">
                        {{userCalculationProfile.referenceDescription}}
                    </strong>
                    <div *ngIf="false">
                        <span>EXP : {{sessionValidTime| date:'yyyy-MM-dd HH:mm:ss'}}</span>
                        <span>NOW : {{currentTime | date:'yyyy-MM-dd HH:mm:ss'}}</span>
                    </div>
                </div>

            </button>
        </div>

    </kendo-appbar-section>

    <!-- <span class="k-appbar-separator navigation-tabs__separator"></span>

  <kendo-appbar-section>
    <app-portal-switcher [allowMainPortal]="true" [allowMobilePortal]="true"
      [allowWorkshopPortal]="true" [allowDealerPortal]="false"></app-portal-switcher>
  </kendo-appbar-section> -->

    <kendo-appbar-section>
        <app-select-localization></app-select-localization>
    </kendo-appbar-section>

    <!-- <kendo-appbar-section>
     <app-user-portal-messages-indicator
      [messageServicingUrl]="'/dealerCenter/messages'"></app-user-portal-messages-indicator>
  </kendo-appbar-section> -->

    <span class="k-appbar-separator navigation-tabs__separator"></span>

    <kendo-appbar-section>
        <a (click)="logoutUser()" role="none" class="navigation-tabs__link"> {{'layout.topToolbarLogout' | translate}}
        </a>
    </kendo-appbar-section>

</kendo-appbar>

<router-outlet></router-outlet>